import { useSelector } from "react-redux";
import { ApplicationState } from "..";

export const useBodyshopTypeReducer = () => useSelector((state: ApplicationState) => state.bodyshopType);
